/* Click-to-play YouTube on guide pages. Iframe is not created until tap. */
(function () {
  var root = document.getElementById('gpc-guide-video');
  if (!root) return;
  var btn = root.querySelector('.gpc-yt-facade');
  var id = root.getAttribute('data-yt');
  if (!btn || !id) return;
  btn.addEventListener('click', function () {
    var iframe = document.createElement('iframe');
    iframe.setAttribute('title', 'YouTube review');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('loading', 'lazy');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
    iframe.className = 'absolute inset-0 w-full h-full';
    iframe.style.border = '0';
    btn.replaceWith(iframe);
  });
})();
